import script from "./CustomCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomCard.vue?vue&type=script&setup=true&lang=ts"

import "./CustomCard.vue?vue&type=style&index=0&id=e9112d9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9112d9e"]])

export default __exports__